import React, {useEffect, useState} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import Loader from 'react-loader';

import styles from './Umk.module.css';
import {useSelector} from 'react-redux';

const Umk = ({history, group, disciplineList, isLoading, didMount}) => {

    const { year } = useSelector((state) => state.umk.group);
    
    useEffect(() => {
      setTabIndex(year - 1);
    }, [year])
    
    const [tabIndex, setTabIndex] = useState(year);

    useEffect(() => {
        didMount();
    }, [didMount]);

    const resolveFinTest = (rowData) => {
        const exams = [];
        if (rowData.fin_exam) 
            exams.push('Экзамен');
        if (rowData.fin_test) 
            exams.push('Зачет');
        if (rowData.fin_test_with_grade) 
            exams.push('Зачет с оценкой');
        if (rowData.fin_test_work) 
            exams.push('Защита курсовой работы');
        
        return exams.length > 0
            ? exams.map((exam, index) => <p key={index}>{exam}</p>)
            : '';
    };

    const disciplineClick = (cid) => {
        const pathname = `/discipline/${cid}/${group.educationPlanId}/${group.syid}/${disciplineList[tabIndex].list.eyid}`;
        const state = {
            tabIndex
        };
        history.push({pathname, state});
        window.scrollTo(0, 0);
    };

    const renderRow = (row) => (
        <tr key={row.cid} onClick={() => disciplineClick(row.cid)}>
            <td colSpan={5}>{row.discipline_meta}</td>
            <td colSpan={1}>{row.s_hrs ?? '-'}</td>
            <td colSpan={1}>{row.i_hrs ?? '-'}</td>
            <td colSpan={1}>{(row.i_hrs ?? 0) + (row.s_hrs ?? 0)}</td>
            <td colSpan={2}>{resolveFinTest(row)}</td>
        </tr>
    );

    const renderTabPanel = (row, index) => {
        const renderedSemesters = Object
            .entries(row.list)
            .filter(([el]) => el !== 'eyid')
            .map(([name, value]) => ({
                ...value,
                name
            }));

        return (
            <TabPanel key={index}>
                <tr>
                    <th className="border-color-themed" colSpan={5}>
                        Дисциплина
                    </th>
                    <th className="border-color-themed" colSpan={1}>
                        Всего часов учебных занятий с преподавателем
                    </th>
                    <th className="border-color-themed" colSpan={1}>
                        Время на самост. работу
                    </th>
                    <th className="border-color-themed" colSpan={1}>
                        Всего часов учебных занятий
                    </th>
                    <th className="border-color-themed" colSpan={2}>
                        Форма итогового контроля
                    </th>
                </tr>
                {renderedSemesters.sort((a, b) => Number(a.name.split(' ')[0]) > Number(b.name.split(' ')[0])
                    ? 1
                    : -1).map((semester, idx) => (
                    <React.Fragment key={idx}>
                        <tr>
                            <td className={styles.semesterRow} colSpan={10}>
                                {semester.name}
                            </td>
                        </tr>
                        {semester
                            .courses
                            .map(renderRow)}
                    </React.Fragment>
                ))}
            </TabPanel>
        );
    };

    const renderTab = (tab, i) => (
        <Tab
            key={i}
            className="table-mark__years_item"
            selectedClassName="table-mark__years_item-active">
            {tab.cours}
        </Tab>
    );

    return (
        <div className="2.jpg upper">
            <div className="31.jpg upper">
                {group.educationPlan
                    ? (
                        <Loader color="#7b2b2a" loaded={!isLoading}>
                            <div className="captions">Рабочие программы дисциплин (модулей)</div>
                            <div className="discipline__block">
                                <span>Группа:</span>
                                {group.name}
                            </div>
                            <div className="discipline__block">
                                <span>Год набора:</span>
                                {group.schoolYear}
                            </div>
                            <div className="discipline__block">
                                <span>Специальность:</span>
                                {group.specialization || group.militaryProfession}
                            </div>
                            <div className="discipline__block">
                                <span>Учебный план:</span>
                                {group.educationPlan}
                            </div>

                            {disciplineList
                                ?.length > 0
                                    ? (
                                        <div className={styles.tableContainer}>
                                            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                                <TabList>{disciplineList.map(renderTab)}</TabList>

                                                <table className="tg-second new__tg_med newWidth">
                                                    {disciplineList.map(renderTabPanel)}
                                                </table>
                                            </Tabs>
                                        </div>
                                    )
                                    : (<Loader isLoading/>)}
                        </Loader>
                    )
                    : (
                        <h3>Данные отсутствуют</h3>
                    )}
            </div>
        </div>
    );
};

export default Umk;
